"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Award_meta_1 = require("../Award.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Image_1 = __importDefault(require("../../../base/Image/Image"));

exports.imageError = function (imageElement) {
  imageElement.src = 'data:image/svg+xml,<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg"/>';
  imageElement.style.display = 'none';
};

var AwardImage = function AwardImage(props) {
  return react_1.default.createElement(Image_1.default, __assign({
    onError: function onError(e) {
      exports.imageError(e.target);
    }
  }, props));
};

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(AwardImage, Award_meta_1.AWARD_CATEGORY_KEY, Award_meta_1.AWARD_COMPONENT_KEY, ['awardImage']);